/** Resolve a presentation label without changing lake/DSL identifiers. */
export function datasetDisplayName(name: string, schema: unknown): string {
  if (typeof schema === 'string') {
    try { schema = JSON.parse(schema); } catch { return name; }
  }
  if (!Array.isArray(schema)) return name;
  for (const column of schema) {
    if (!column || typeof column !== 'object') continue;
    const { source_sheet, source_file } = column;
    if (typeof source_sheet === 'string' && source_sheet.trim()) return source_sheet;
    if (typeof source_file === 'string' && /\.csv$/i.test(source_file)) {
      const stem = (source_file.replace(/\\/g, '/').split('/').pop() ?? '').replace(/\.csv$/i, '');
      if (stem.trim()) return stem;
    }
  }
  for (const column of schema) {
    if (!column || typeof column !== 'object') continue;
    const { source_schema, source_table } = column;
    if (typeof source_schema === 'string' && source_schema.length > 0
      && typeof source_table === 'string' && source_table.length > 0) {
      return `${source_schema}.${source_table}`;
    }
  }
  return name;
}

export function selectedEntityLabels(
  entities: ReadonlyArray<{ entity_name: string; label: string }>,
): ReadonlyMap<string, string> {
  return new Map(entities.filter(entity => entity.label.trim()).map(entity => [entity.entity_name, entity.label]));
}

/** Combine status labels with saved selections, preserving internal map keys. */
export function ingestionDatasetLabels(
  datasets: ReadonlyArray<{ name: string; display_name?: string | null }>,
  selections: ReadonlyMap<string, string>,
): ReadonlyMap<string, string> {
  const labels = new Map(selections);
  for (const dataset of datasets) {
    if (dataset.display_name?.trim()) labels.set(dataset.name, dataset.display_name);
  }
  return labels;
}

/** Replace complete internal identifiers in messages, without rewriting stored events. */
export function datasetMessageDisplayName(
  message: string | null | undefined, labels: ReadonlyMap<string, string>,
): string | undefined {
  if (!message || labels.size === 0) return message ?? undefined;
  // One pass avoids interpreting replacement labels as more internal identifiers.
  return message.replace(/[A-Za-z0-9_]+/g, token => labels.get(token) || token);
}